















































































import { Component, Vue } from "vue-property-decorator";
import { bus } from "@/main.ts";
import { Getter } from "vuex-class";
import { Instance } from "@/services/instances/types";
import { getInstances, getOneTimeToken } from "@/services/instances/instanceService";
import { instancesFields } from "@/components/instances/fields/instancesFields";
import { RoleEnum } from "@/store/authentication/types";
const namespace: string = "authentication";

@Component
export default class Instances extends Vue {
    @Getter("reload") reload: any;
    @Getter("authorize", { namespace }) authorize: any;
    roles = RoleEnum;

    // local state
    instances = [] as Array<Instance>;
    fields = instancesFields;
    isBusy = false;
    sortBy = "name";
    sortDesc = false;

    // filter options
    searchQuery = "";
    // lifecycle hooks
    public created(): void {
        this.fetchData();

        bus.$on("reload", () => {
            this.fetchData();
        });
    }

    beforeDestroy() {
        bus.$off("reload");
    }

    // computed

    get filteredData() {
        return this.instances && this.instances
            .filter(x => this.searchQuery.length === 0 ||
                (x.name.toLowerCase().includes(this.searchQuery.toLowerCase())));
    }

    // methods
    navigateToInstance(id: string, baseUrl: string) {
        getOneTimeToken(id).then(response => {
            window.open(
                `${baseUrl}/oneTimeLogin?t=${response}`,
                "_blank"
            );
        });
    }

    fetchData() {
        this.isBusy = true;
        getInstances().then(response => {
            this.instances = response;
            this.isBusy = false;
        });
    }
}
